import { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  NoDataFoundTemplate,
  Select,
  LoadingComponent,
  DownloadButton,
  MultiSelect,
} from "../../../components/core";
import { ContentContainer } from "../../../components/layout";
import {
  AGGREGATE_POD_TRANSACTIONS,
  QUERY_COMPANY_NKCNAME,
  QUERY_POD_DATA,
} from "../../../constants/graphql/POD-queries";
import { useLazyQuery, useQuery } from "@apollo/client";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { getSixMonthsAgo, toUTCDateTimeString } from "../../../algorithms/date";
import { FILTER_PACKAGES } from "../../../constants/graphql/view-package-history-queries";
import { QUERY_LOCKER_TYPE } from "../../../constants/graphql/drop-off-graphql";
import { InputText } from "primereact/inputtext";
import { paymentCurrency } from "../overstay-fees-report";
import TransactionCard from "../overstay-fees-report/transaction-card";
import AggregateStorageRentalFeesTable from "../storage-rentals-report/aggregate-storage-rental-table";
import OverstayFeesTable from "../overstay-fees-report/overstay-fees-report-table";
import { NEWEST_LOCKER_NAME_QUERY } from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import { formatDate as globalFormatDate } from "../../../algorithms/date";
import { Card } from "primereact/card";
import { computeAggregate } from "../../../utils/compute-aggregate";
import { findLockerName } from "../../../utils/find-locker-by-id";
import { LOCKER_INFO } from "../../../constants/graphql/locker-queries";

const PODReports = () => {
  //variables
  const maxStartDate = getSixMonthsAgo();

  const [filterVariables, setFilterVariables] = useState({
    transactionStatus: "-1",
    mobileNumFilter: "",
    waybillNumFilter: "",
    lockerType: "-1",
    selectedLockerName: [],
    paymentIdFilter: "",
    paymentCurrencyFilter: "-1",
    startDate: maxStartDate,
    endDate: new Date(),
    endTime: "23:59",
    startTime: "00:00",
  });
  const [showTransactionNumber, setShowRedemptionTransactionNum] =
    useState(false);
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [noResultSearch, setNoResultSearch] = useState(true);
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [totalAmt, setTotalAmt] = useState({
    php: 0,
    coins: 0,
  });
  const [totalTransactions, setTotalTransactions] = useState({
    php: 0,
    coins: 0,
  });
  const [totalSuccessTrans, setTotalSuccessTrans] = useState({
    storage: {
      php: 0,
      coins: 0,
    },
    dropOff: {
      php: 0,
      coins: 0,
    },
    subtotal: 0,
  });
  const [totalFailedTrans, setTotalFailed] = useState({
    storage: {
      php: 0,
      coins: 0,
    },
    dropOff: {
      php: 0,
      coins: 0,
    },
    subtotal: 0,
  });
  const [allLockersSelected, setAllLockersSelected] = useState(false);

  const [userNumber, setUserNumber] = useState("");

  //setter variables
  const [partnerCompany, setPartnerCompany] = useState([]);
  const [selectedPartnerCompany, setSelectedPartnerCompany] = useState("-1");
  const [lockerName, setLockerName] = useState([]);
  const [lockerType, setLockerType] = useState([]);

  const [podTableData, setPODTableData] = useState([]);

  const [selectedPaymentMode, setSelectedPaymentMode] = useState("-1");
  const [searchResultHeader, setSearchResultHeader] = useState("");

  const dt = useRef(null);

  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  // gql query
  const [fsetchAllPODData, { data: podLazyData, loading: loadingPODData }] =
    useLazyQuery(QUERY_POD_DATA);
  const [
    fetchAggregatePODData,
    { data: aggregatePODData, loading: loadingAggregateData },
  ] = useLazyQuery(AGGREGATE_POD_TRANSACTIONS);
  const fetchCompanyName = useQuery(QUERY_COMPANY_NKCNAME, {
    variables: {
      operatorId: operatorId,
    },
  });

  const [fetchLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY
  );
  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);

  const transActStatus = [
    { value: "1", name: "Successful" },
    { value: "2", name: "Failed" },
  ];
  const { data: allLockerNames } = useQuery(LOCKER_INFO, {
    variables: {
      operatorId: operatorId,
    },
  });
  const [nameData, setNameData] = useState([]);

  useEffect(() => {
    if (allLockerNames && allLockerNames.lockerInfo) {
      const lockerDetails = allLockerNames.lockerInfo.map((locker) => ({
        lockerId: locker.lockerId,
        lockerName: locker.lockerName,
      }));
      setNameData(lockerDetails);
    }
  }, [allLockerNames]);
  // find the matching lockerId from the nameData
  // const findLockerName = (lockerId, nameData) => {
  //   const locker = nameData.find(
  //     (locker) => parseInt(locker.value) === parseInt(lockerId)
  //   );
  //   console.log({ lockerId, nameData, locker });

  //   return locker ? locker.label : null;
  // };
  const modeOfPayment = [
    { value: "1", name: "GCash" },
    { value: "2", name: "PayMaya" },
    { value: "3", name: "GrabPay" },
  ];

  //To display search result in header
  function handleSearchResultHeader() {
    const partnerCompanyName =
      selectedPartnerCompany === -1 || selectedPartnerCompany === ""
        ? "ALL Partners"
        : partnerCompany.find((item) => item.value === selectedPartnerCompany);

    const lockerTypeName =
      filterVariables.lockerType === "-1"
        ? "ALL Locker types"
        : filterVariables.lockerType === "1"
        ? "Parcel Locker"
        : "Fridge Locker";

    let lockerNameText;
    if (allLockersSelected) {
      lockerNameText = "ALL Lockers";
    } else {
      const lockerLabels = filterVariables.selectedLockerName
        .map((selectedLocker) => {
          const matchedLocker = lockerName.find(
            (item) => parseInt(item.value) === parseInt(selectedLocker.value)
          );
          return matchedLocker ? matchedLocker.label : null;
        })
        .filter((label) => label !== null);

      lockerNameText =
        lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
    }

    const mobileHeader =
      filterVariables.mobileNumFilter !== ""
        ? filterVariables.mobileNumFilter
        : "ALL Mobile Numbers";

    const waybillHeader =
      filterVariables.waybillNumFilter !== ""
        ? filterVariables.waybillNumFilter
        : "ALL Packages";

    const transActNameValue =
      filterVariables.transactionStatus === -1 ||
      filterVariables.transactionStatus === "-1"
        ? ""
        : transActStatus.find(
            (item) => item.value === filterVariables.transactionStatus
          );
    const transActNameText =
      transActNameValue !== ""
        ? `${transActNameValue.name} Transactions`
        : "ALL Transaction Status";

    const modePaymentValue =
      selectedPaymentMode === -1 || selectedPaymentMode === ""
        ? `ALL Payment Modes`
        : modeOfPayment.find((item) => item.value === selectedPaymentMode);

    // const transactID =
    // 	userNumber !== null ? `Transaction ID: ${userNumber}, in` : "";
    const paymentIDHeader =
      filterVariables.paymentIdFilter !== ""
        ? `Payment ID: ${filterVariables.paymentIdFilter}`
        : "";

    setSearchResultHeader(`for
					${transActNameText},
					${lockerTypeName},
					${lockerNameText},
					${mobileHeader},
					${waybillHeader},
					${paymentIDHeader},
					from ${globalFormatDate(filterVariables.startDate)} to ${globalFormatDate(
      filterVariables.endDate
    )}
    `);
  }

  // fetch table data directly from graphql
  //To Fetch Company Name
  useEffect(() => {
    if (fetchCompanyName.data) {
      let tempData = [];
      fetchCompanyName.data.partners.forEach((element) => {
        tempData.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      setPartnerCompany(tempData);
    }
  }, [fetchCompanyName.data]);

  //to fetch lockerName
  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = filterVariables.selectedLockerName;
    const allLockers = lockerName;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [filterVariables.selectedLockerName, lockerName]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      setFilterVariables({
        ...filterVariables,
        selectedLockerName: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerName]);

  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element) =>
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        })
      );
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  useEffect(() => {
    if (filterVariables.lockerType !== "-1") {
      fetchLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: filterVariables.lockerType,
        },
      });
    }
  }, [filterVariables.lockerType, operatorId]);

  const buildVariables = () => {
    const updatedVariables = {};
    const operatorId = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "";

    // always assign operatorid
    updatedVariables.operatorId = operatorId;

    if (filterVariables.transactionStatus !== "-1") {
      updatedVariables.transactionStatus = filterVariables.transactionStatus;
    }

    if (filterVariables.mobileNumFilter !== "") {
      updatedVariables.mobileNumber = filterVariables.mobileNumFilter;
    }

    if (filterVariables.lockerType !== "-1") {
      updatedVariables.lockerType = filterVariables.lockerType;
    }

    if (filterVariables.selectedLockerName.length !== 0) {
      const lockerIdValues = filterVariables.selectedLockerName.map(
        (locker) => locker.value
      );

      updatedVariables.lockerIds = lockerIdValues;
    }

    if (filterVariables.paymentIdFilter !== "") {
      updatedVariables.paymentId = filterVariables.paymentIdFilter;
    }

    if (filterVariables.paymentCurrencyFilter !== "-1") {
      updatedVariables.paymentCurrency =
        filterVariables.paymentCurrencyFilter === "1" ? "PHP" : "PHMC";
    }

    if (filterVariables.startDate) {
      updatedVariables.transactionDateStart = toUTCDateTimeString(
        new Date(filterVariables.startDate),
        filterVariables.startTime || "00:00"
      );
    }

    if (filterVariables.endDate) {
      updatedVariables.transactionDateEnd = toUTCDateTimeString(
        new Date(filterVariables.endDate),
        filterVariables.endTime || "23:59"
      );
    }

    if (filterVariables.waybillNumFilter) {
      updatedVariables.waybillNumber = filterVariables.waybillNumFilter;
    }
    return updatedVariables;
  };

  //search handler
  const handleSearch = () => {
    setIsLoading(true);
    setIsClicked(true);
    setShowRedemptionTransactionNum(false);
    setFilterButtonClicked(true);
    handleSearchResultHeader();

    const variable = buildVariables();
    // Case 1: No locker selected
    if (filterVariables.selectedLockerName.length === 0) {
      // If lockerType is not -1, user must pick a locker
      if (filterVariables.lockerType !== "-1") {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Invalid Locker",
          message: `Please select a locker name.`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });

        setIsLoading(false);
        setIsClicked(false);
        return;
      }

      // Else it's okay to proceed with fetchAggregatePODData
      fetchAggregatePODData({
        variables: variable,
        fetchPolicy: "network-only",
      });
      return;
    }

    // Case 2: Locker name selected → fetch detailed data
    fsetchAllPODData({
      variables: variable,
      fetchPolicy: "network-only",
    });
  };

  useEffect(() => {
    if (!isClicked) return;
    if (filterVariables.selectedLockerName.length !== 0) return; // Only for aggregate

    if (aggregatePODData && aggregatePODData.aggregatePodTransactions) {
      if (aggregatePODData.aggregatePodTransactions.length > 0) {
        const {
          tableData,
          totalAmt: amt,
          statusBySvc,
          totalTxns,
        } = computeAggregate(
          aggregatePODData.aggregatePodTransactions,
          nameData,
          findLockerName,
          {
            includeRefunds: false,
          }
        );

        setPODTableData(tableData);
        setTotalAmt(amt);
        setTotalSuccessTrans(statusBySvc.success);
        setTotalFailed(statusBySvc.failed);
        setTotalTransactions(totalTxns);
      } else {
        setPODTableData([]);
      }
      setIsLoading(false);
    }
  }, [
    aggregatePODData,
    nameData,
    isClicked,
    filterVariables.selectedLockerName.length,
  ]);

  useEffect(() => {
    if (!isClicked) return;
    if (filterVariables.selectedLockerName.length === 0) return; // Only for detailed

    if (podLazyData && podLazyData.transactions) {
      if (podLazyData.transactions.length > 0) {
        const {
          tableData,
          totalAmt: amt,
          statusBySvc,
          totalTxns,
        } = computeAggregate(
          podLazyData.transactions,
          nameData,
          findLockerName
        );

        setPODTableData(tableData);
        setTotalAmt(amt);
        setTotalSuccessTrans(statusBySvc.success);
        setTotalFailed(statusBySvc.failed);
        setTotalTransactions(totalTxns);
      } else {
        setPODTableData([]);
      }
      setIsLoading(false);
    }
  }, [
    podLazyData,
    nameData,
    isClicked,
    filterVariables.selectedLockerName.length,
  ]);

  // handle change filter variables
  const handleFilterChange = (e, field) => {
    setIsClicked(false);
    const value = e.target.value;
    if (field === "lockerType") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedLockerName: [],
      });
    } else {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
      });
    }
  };
  return (
    <ContentContainer containerTitle={"Payment on Delivery Report"}>
      <div>
        <h2 className={"font-bold"}>Transaction Details:</h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          {/* <div>Partner Name:</div>
					<Select
						items={partnerCompany}
						value={selectedPartnerCompany}
						defaultOption={{ value: "-1", name: "--- ALL ---" }}
						onChange={(event) => {
							setSelectedPartnerCompany(event.target.value);
						}}
					/> */}

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className="col-span-1">Transaction Status:</div>
              <Select
                items={transActStatus}
                className={"col-span-2"}
                value={filterVariables.transactionStatus}
                defaultOption={{ value: "-1", name: "--- ALL ---" }}
                onChange={(event) => {
                  handleFilterChange(event, "transactionStatus");
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-12 w-full items-center">
              <div className={"col-span-4"}>Recipient Mobile:</div>

              <div className={"col-span-1"}>+63</div>
              <InputText
                keyfilter={"int"}
                placeholder={"XXXXXXXXX"}
                useGrouping={false}
                maxLength={10}
                value={filterVariables.mobileNumFilter}
                onChange={(event) => {
                  handleFilterChange(event, "mobileNumFilter");
                }}
                className="col-span-4 px-4 "
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-12 w-full items-center">
              <div className={"col-span-4"}>Waybill Number:</div>

              <InputText
                placeholder={"XXXXXXXXX"}
                maxLength={32}
                value={filterVariables.waybillNumFilter}
                onChange={(event) => {
                  handleFilterChange(event, "waybillNumFilter");
                }}
                className="col-span-5 px-4 "
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>
          Locker:
          <span className="font-normal text-xs italic ml-2 text-blue-700">
            (to view each transaction, please select locker type and locker name
            from the list)
          </span>
        </h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Locker Type:</div>
              <Select
                defaultOption={{ value: "-1", name: "--- ALL ---" }}
                items={lockerType}
                className={"col-span-2"}
                value={filterVariables.lockerType}
                onChange={(event) => {
                  // setAllLockersSelected(false);
                  // setFilterVariables({
                  //   ...filterVariables,
                  //   selectedLockerName: [],
                  // });

                  handleFilterChange(event, "lockerType");
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Locker Name:</div>
              {/* <Select
						defaultOption={{ value: "-1", name: "--- ALL ---" }}
						items={lockerName}
						value={selectedLockerName}
						onChange={(event) => {
							setSelectedLockerName(event.target.value);
						}}
					/> */}
              <MultiSelect
                // className=""
                items={lockerName}
                className={"col-span-2"}
                placeholder={`${
                  filterVariables.lockerType === "-1"
                    ? "ALL Lockers"
                    : "Select..."
                }`}
                value={filterVariables.selectedLockerName}
                disabled={filterVariables.lockerType === "-1"}
                onChange={(event) => {
                  // setSelectedLockerName(event.target.value);
                  handleFilterChange(event, "selectedLockerName");
                }}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>
          Payment Details:{" "}
          {/* <span className="font-normal text-xs italic ml-2 text-blue-700">
						(to filter by payment date, please select a locker name)
					</span> */}
        </h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          {/* <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment ID:</div>
              <InputText
                keyfilter={"int"}
                placeholder={"XXXX"}
                className={"col-span-2 px-4"}
                value={filterVariables.paymentIdFilter}
                maxLength={32}
                onChange={(event) => {
                  handleFilterChange(event, "paymentIdFilter");
                }}
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div> */}

          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment Currency:</div>
              <Select
                items={paymentCurrency}
                className={"col-span-2"}
                value={filterVariables.paymentCurrencyFilter}
                onChange={(event) => {
                  // setPaymentCurrencyFilter(event.target.value);
                  handleFilterChange(event, "paymentCurrencyFilter");
                }}
                defaultOption={{ value: "-1", name: "-- ALL--" }}
              />
            </div>
          </div>

          {/* <div>Payment Gateway:</div>
					<Select
						defaultOption={{ value: "-1", name: "--- ALL ---" }}
						items={paymentGatewayOptions}
						value={selectedPaymentGateways}
						onChange={(event) => {
							setSelectedPaymentGateway(event.target.value);
						}}
					/> */}

          {/* {filterVariables.selectedLockerName.length !== 0 && ( */}
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Payment Date filter:</div>
              <PrimereactDateRange
                className={`col-span-2`}
                timeOnly={true}
                startTime={filterVariables.startTime}
                endTime={filterVariables.endTime}
                startDate={filterVariables.startDate}
                endDate={filterVariables.endDate}
                startDateName="startDate"
                endDateName="endDate"
                startTimeName="startTime"
                endTimeName="endTime"
                onChange={(event, fieldName) => {
                  handleFilterChange(event, fieldName);
                }}
                readOnlyInput={true}
                max={new Date()}
                // min={new Date(threeMonthsFromNow.toISOString().split("T")[0])}
                // min={maxStartDate}
              />
            </div>
          </div>
        </div>

        <h2 className={"font-bold pt-4"}>Partner:</h2>
        <div className={"grid grid-cols-8 items-center w-full gap-y-2"}>
          <div className="col-span-6 grid">
            <div className="grid grid-cols-3 w-full items-center">
              <div className={"col-span-1"}>Partner Name:</div>
              <Select
                disabled
                items={partnerCompany}
                value={selectedPartnerCompany}
                className={"col-span-2"}
                defaultOption={{ value: "-1", name: "--- ALL ---" }}
                onChange={(event) => {
                  setSelectedPartnerCompany(event.target.value);
                }}
              />
            </div>
          </div>
          <div className="col-span-2"></div>
        </div>

        <div className="grid grid-cols-12 gap-y-2">
          <div className="col-span-8"></div>
          <u
            className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
            onClick={() => {
              const threeMonthsAgo = new Date();
              threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

              setFilterVariables({
                ...filterVariables,
                startDate: maxStartDate,
                endDate: new Date(),
                selectedLockerName: [],
                transactionStatus: "-1",
                mobileNumFilter: "",
                waybillNumFilter: "",
                lockerType: "-1",
                paymentIdFilter: "",
                paymentCurrencyFilter: "-1",
                endTime: "23:59",
                startTime: "00:00",
              });
              // setPODTableData([]);
              setIsClicked(false);
            }}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="ml-1">Reset</p>
          </u>
        </div>

        <Button
          value={"Search"}
          disabled={loadingAggregateData || loadingPODData}
          onClick={handleSearch}
          className={"w-40 h-8 m-5"}
        />

        {isClicked &&
          (loadingAggregateData || loadingPODData ? (
            <LoadingComponent />
          ) : podTableData.length === 0 ? (
            <NoDataFoundTemplate />
          ) : (
            <Card className="mx-4">
              <div
                className={`pt-2 ${podTableData.length === 0 ? "hidden" : ""}`}
              >
                <div className="mt-5">
                  {/* <>
                    <Checkbox
                      disabled={filterVariables.selectedLockerName.length === 0}
                      checked={showTransactionNumber}
                      onChange={togglePaymentIDVisiblity}
                      label="Show More Payment Details"
                    />
                  </> */}

                  <DownloadButton dt={dt} csvOnly={true} />
                  <div className={" bg-yellow-400 p-2 "}>
                    <div className={"text-center"}>
                      <span>
                        <h1 className={"font-bold"}>POD REPORTS</h1>
                      </span>
                      <span>
                        <h1 className={"font-bold"}>{searchResultHeader} </h1>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="p-2 grid grid-cols-8">
                  <div className={`col-span-1`}></div>

                  {(filterVariables.paymentCurrencyFilter === "-1" ||
                    filterVariables.paymentCurrencyFilter === "1") && (
                    <div
                      className={`px-2 ${
                        filterVariables.paymentCurrencyFilter === "-1"
                          ? "col-span-3"
                          : "col-span-6"
                      }`}
                      style={{ display: "grid" }}
                    >
                      <TransactionCard
                        currencyType={"PHP"}
                        data={podTableData}
                        totalAmt={totalAmt}
                        totalTransactions={totalTransactions.total}
                        totalSuccessTrans={totalSuccessTrans}
                        totalFailedTrans={totalFailedTrans}
                      />
                    </div>
                  )}

                  {(filterVariables.paymentCurrencyFilter === "-1" ||
                    filterVariables.paymentCurrencyFilter === "2") && (
                    <div
                      className={`px-2 ${
                        filterVariables.paymentCurrencyFilter === "-1"
                          ? "col-span-3"
                          : "col-span-6"
                      }`}
                      style={{ display: "grid" }}
                    >
                      <TransactionCard
                        currencyType={"MBOX COINS"}
                        data={podTableData}
                        totalAmt={totalAmt}
                        totalTransactions={totalTransactions.total}
                        totalSuccessTrans={totalSuccessTrans}
                        totalFailedTrans={totalFailedTrans}
                      />
                    </div>
                  )}
                  <div className={`col-span-1`}></div>
                </div>

                {filterVariables.selectedLockerName.length === 0 ? (
                  <>
                    <AggregateStorageRentalFeesTable
                      dt={dt}
                      items={podTableData}
                      isStorage={false}
                      showMorePaymentDetails={showTransactionNumber}
                    />
                  </>
                ) : (
                  <OverstayFeesTable
                    dt={dt}
                    isForPOD={true}
                    multiItemField={false}
                    items={podTableData}
                    showMorePaymentDetails={showTransactionNumber}
                  />
                )}
              </div>
            </Card>
          ))}
      </div>
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
};
export default PODReports;
